/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */


import React from "react";
import {ServiceDrivenTableColumn} from "../../../../Common/FileBrowser/ServiceDrivenTableColumn";
import {SpeciesListNameTableColumn} from "./SpeciesListNameTableColumn";
import {service as OrganizationService} from "../../../../../Services/OrganizationService";
import {service as SpeciesListTypeService} from "../../../../../Services/SpeciesListTypeService";
import {service as StateService} from "../../../../../Services/StateService";

export const customListName = {
	title: "Name",
	key: "name",
	sortable: true,
	logic: (x) => x.name,
	renderer: SpeciesListNameTableColumn
};

export const speciesListType = {
    title: "Type",
    key: "speciesListTypeId",
    sortable: true,
    logic: x => x.speciesListTypeId,
    renderer: ServiceDrivenTableColumn(SpeciesListTypeService)
};

export const customListState = { 
    title: "State",
    key: "stateId",
    sortable: true,
    logic: x => x.stateId,
    renderer: ServiceDrivenTableColumn(StateService),
};

export const organization = {
	title: "Organization",
	key: "organizationId",
	sortable: true,
	logic: x => x.organizationId,
	sortLogic: x => OrganizationService.CachedTitleById(x.organizationId),
	renderer: ServiceDrivenTableColumn(OrganizationService)
};
